import {ReactComponent as LockIcon} from '../../../assets/scenario/lock.svg';
import {ReactComponent as UnLockIcon} from '../../../assets/scenario/unlock.svg';
import { IoIosClose } from 'react-icons/io';
import styles from './styles/voca.module.css';

export default function ScenarioVoca({ id, index, scenarioWord, updateMode, handleDeleteWord }) {
    return (
        <div className={styles.scenarioWordCont}>
            <div className={styles.scenarioWordGroup}>
                <p className={styles.scenarioWordP}>{scenarioWord.name}</p>
                {updateMode[id] ? (
                    <button onClick={() => handleDeleteWord(id, index)} className={styles.closeButton}>
                        <IoIosClose className={styles.closeIcon} />
                    </button>
                )
                : scenarioWord.isPublic
                    ? <UnLockIcon style={{maxHeight: '11px', margin: '0 0 -1px 4px'}}/>
                    : <LockIcon style={{maxHeight: '11px', margin: '0 0 -1px 4px'}}/>}
            </div>
        </div>
    );
}
